// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-site__box-carousel[data-v-3a873f9e] {\n    max-width: 100%;\n}\n@media (min-width: 992px) {\n.main-site__box-carousel[data-v-3a873f9e] {\n        max-width: 75%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
